import { fork } from 'redux-saga/effects';
import type { ForkEffect } from 'redux-saga/effects';
import featureFlagsSaga from 'store/launchDarkly/saga';

/**
 * Root application saga, uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* root(): Generator<ForkEffect<void>, void, unknown> {
  yield fork(featureFlagsSaga);
}
